'use client'
import { Language } from '@/localization/localization.types'
import createContextProvider from '../context-factories/create-context-provider'
import withSuspendedContext from '../context-factories/with-suspended-context'

const [Provider, useProvider] = createContextProvider<{
  currency: string
  locale: Language
}>()

const [CurrencyProvider, useCurrencyProvider, withCurrencyProviderSuspense] =
  withSuspendedContext(Provider, useProvider)

const useCurrency = () => {
  const { currency } = useCurrencyProvider()
  return currency
}

const useCurrencyFormatter = () => {
  const { locale, currency } = useCurrencyProvider()
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format
}

const usePercentFormatter = () => {
  const locale = useLocale()
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format
}

const useLocale = () => {
  const { locale } = useCurrencyProvider()
  return locale
}

export {
  CurrencyProvider,
  withCurrencyProviderSuspense,
  useCurrency,
  useCurrencyFormatter,
  useLocale,
  usePercentFormatter,
}
